import styled, { contentMargins, css, gapSize, rem, screenMobilePlusAndSmaller, spacingBase } from 'theme';

export const Footer = styled('footer')`
  background-color: var(--ref-color-blackwhite-black);
`;

export const List = styled('div')`
  display: flex;
  align-items: center;
  font-size: ${rem(13)};

  ${contentMargins(1)}

  ${screenMobilePlusAndSmaller(css`
    align-items: flex-start;
    flex-direction: column;
  `)};
`;

export const Item = styled('div')`
  color: var(--ref-color-gray-30);
  padding-right: ${() => spacingBase};

  a {
    color: var(--ref-color-gray-30);
    text-decoration: underline;
  }
`;

export const ItemLogo = styled(Item)`
  display: flex;
  align-items: center;
  color: var(--ref-color-gray-30);

  svg {
    width: ${rem(15)};
    height: ${rem(15)};
    margin-right: ${() => gapSize(0.5)};
  }
`;
